import { render, staticRenderFns } from "./FileWithIcon.vue?vue&type=template&id=fc780f70&"
import script from "./FileWithIcon.vue?vue&type=script&lang=ts&"
export * from "./FileWithIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports